import React from 'react';
import useScrollToTop from '../components/useScrollToTop';
import Button from '../components/Button';
import './floorpages.css';
import vastuPlan1 from '../img/living_room_img_1.avif'; // Replace with relevant image
import vastuPrinciplesBihar from '../img/living_room_img_2.avif'; // Replace with relevant image
import vastuFriendlyLayout from '../img/living_room_img_3.avif'; // Replace with relevant image
import ReusableLanding from '../components/ReusableLanding';
const PageVastuHomeNaksha = () => {
  useScrollToTop();

  return (
    <>
     <ReusableLanding
        imageUrl={vastuPlan1}
        title="Home plans with Vastushastra"
        description="Incorporate the ancient science of Vastu Shastra into your home design in Patna for positive energy flow, harmony, and well-being. Our Vastu-compliant house nakshas are thoughtfully designed to align with these principles, ensuring a balanced and prosperous living environment for you and your family in Bihar."
    />
<div className='project-container'>
  <div className="project-details">
    <h2 className="">House Plans Based on Vastu Shastra</h2>
    <p className="">
      Incorporate the ancient science of Vastu Shastra into your home design in Patna for positive energy flow, harmony, and well-being. Our Vastu-compliant house nakshas are thoughtfully designed to align with these principles, ensuring a balanced and prosperous living environment for you and your family in Bihar.
    </p>

    <h2 className="">Key Vastu Shastra Principles for Homes in Patna</h2>
    <ul className="list-items">
      <li>
        <strong>Orientation and Placement:</strong> Aligning the house and rooms according to cardinal directions for optimal energy flow, considering the specific plot in Patna.
        <div className="img-container">
          <img src={vastuPrinciplesBihar} alt="Vastu Shastra Principles for Home Orientation in Bihar" className="project-image" />
        </div>
      </li>
      <li>
        <strong>Entrance Direction:</strong> The main entrance ('Mukha') is carefully positioned to invite positive vibrations.
      </li>
      <li>
        <strong>Room Placement:</strong> Locating specific rooms like the kitchen (southeast), pooja room (northeast), and bedrooms according to Vastu guidelines.
        <div className="img-container">
          <img src={vastuFriendlyLayout} alt="Vastu Friendly House Layout in Patna" className="project-image" />
        </div>
      </li>
      <li>
        <strong>Shape and Size:</strong> Ensuring the plot and house have regular and auspicious shapes.
      </li>
      <li>
        <strong>Water Elements:</strong> Proper placement of water sources to maintain balance.
      </li>
    </ul>

    <h2 className="">Explore Our Collection of Vastu Compliant House Plans for Patna</h2>
    <ul className="list-items">
      <li>A range of house plans designed in accordance with Vastu Shastra principles suitable for Patna.</li>
      <li>Clear indication of Vastu compliance for each plan.</li>
      <li>Options for different sizes and architectural styles, all adhering to Vastu guidelines.</li>
      <li>Consideration for common Vastu requirements in homes in Bihar.</li>
      <li>Integration of modern design elements with traditional Vastu principles.</li>
    </ul>

    <h2 className="">Detailed AutoCAD 2D Drawings Incorporating Vastu for Your Patna Home</h2>
    <p className="">
      Our detailed AutoCAD 2D drawings not only provide precise architectural layouts but also integrate key Vastu Shastra principles to ensure a harmonious and positive living space in Patna.
      <div className="img-container">
        <img src={vastuPlan1} alt="Vastu Compliant House Plan for Patna" className="project-image" />
      </div>
    </p>
    <ul className="list-items">
      <li>Floor plans clearly marking Vastu-compliant room placements and orientations.</li>
      <li>Detailed layout of the main entrance according to auspicious directions.</li>
      <li>Placement of water elements and other key features as per Vastu.</li>
      <li>Overall design that promotes positive energy flow within the home in Patna.</li>
    </ul>
     <div className="">
          <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
            <Button className="button-outlined">वास्तु शास्त्र के अनुसार घर का डिज़ाइन बनवाने के लिए हमसे संपर्क करें!</Button>
          </a>
        </div>
  </div>
  </div>
    </>
  );
};

export default PageVastuHomeNaksha;